import {  call, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { selectDevice } from '../../../state/device/deviceSlice';

export function* pickParkedCallSaga(action) {
    try {
        // Fetch user credentials from Redux store
        const callid = action.payload
        const { uid, domain } = yield select(selectUserCredentials);
        const {DeviceUser} = yield select(selectDevice);

        // API endpoint for picking up parked call
        const apiUrl = '?object=call&action=xfer';
        // Parameters for the API call
        const params = {
            callid: callid,
            destination:`sip:${DeviceUser}@${domain}`,
            uid: uid,
            domain: domain,

        };

        // Make the API call with the credentials
        const response = yield call(cirrusClient.get, apiUrl, { params });
        console.log('[VERBOSE] This is the response', response)
    } catch (error) {
        console.error('Error picking up parked call:', error);
    }
}
